module.exports = __webpack_public_path__ + "static/img/list-icon-rewarding.f707e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/vip/list-icon-rewarding.png
// module id = AO9l
// module chunks = 0 1 2 3 4 5 6